// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".partners-flex[data-v-3a02149e]{display:flex;grid-gap:8px;gap:8px;align-items:center;justify-content:center;padding-bottom:20px}.partners-flex .item[data-v-3a02149e]{display:block;flex:1}.partners-flex img[data-v-3a02149e]{display:block;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
